/**
 * TAN-8655 — Punto de montaje del título de página por ruta (WCAG 2.4.2).
 *
 * Por qué es un componente y no un `useEffect` dentro de `Routes.js`:
 *
 * - Es el punto de enganche de MS3 (TAN-9802, mover el foco al landmark principal al navegar): la misma
 *   señal de "ha cambiado la ruta" sirve para las dos cosas, y los dos routers ya lo montan.
 * - No duplica lógica entre el router estándar y el de Edelvives, que solo difieren en las rutas,
 *   el `appName` y la regla de exactitud.
 *
 * No recibe props: cuanto necesita lo resuelve `PageTitleProvider`, que es quien recorre las
 * rutas. Debe montarse dentro de ese provider.
 *
 * Lo que NO hace: no gestiona el foco (eso es TAN-9802), y no escribe el título de las rutas que lo
 * delegan en su página (ver `PageTitle`).
 */

import useRouteChangeHandler from 'app/router/useRouteChangeHandler';

function RouteChangeHandler(): null {
  useRouteChangeHandler();

  return null;
}

export default RouteChangeHandler;
